// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../BrowserStyle.bs.js");

function BrowserComponents_Spacer(Props) {
  var size = Props.size;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.paddingTop(Curry._1(BrowserStyle.Spacing.toSpacing, size)),
                    tl: {
                      hd: Css.paddingLeft(Curry._1(BrowserStyle.Spacing.toSpacing, size)),
                      tl: /* [] */0
                    }
                  })
            });
}

var make = BrowserComponents_Spacer;

exports.make = make;
/* Css Not a pure module */
